import { render, staticRenderFns } from "./CreateClassMenuFile.vue?vue&type=template&id=f5708274&scoped=true"
import script from "./CreateClassMenuFile.vue?vue&type=script&lang=js"
export * from "./CreateClassMenuFile.vue?vue&type=script&lang=js"
import style0 from "./CreateClassMenuFile.vue?vue&type=style&index=0&id=f5708274&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5708274",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5708274')) {
      api.createRecord('f5708274', component.options)
    } else {
      api.reload('f5708274', component.options)
    }
    module.hot.accept("./CreateClassMenuFile.vue?vue&type=template&id=f5708274&scoped=true", function () {
      api.rerender('f5708274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/CreateClassMenuFile.vue"
export default component.exports